import { render, staticRenderFns } from "./custom-icon-exclamation.vue?vue&type=template&id=145196d3&scoped=true"
import script from "./custom-icon-exclamation.vue?vue&type=script&lang=js"
export * from "./custom-icon-exclamation.vue?vue&type=script&lang=js"
import style0 from "./custom-icon-exclamation.vue?vue&type=style&index=0&id=145196d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145196d3",
  null
  
)

export default component.exports